import React from 'react';
import { SC } from '../../styles/theme';
import { BRAND } from '../../constants/main';
import { CheckoutTitleStyledAC } from './AC/CheckoutTitleStyled.AC';
import { CheckoutTitleStyledAP } from './AP/CheckoutTitleStyled.AP';
import { CheckoutTitleStyledDS } from './DS/CheckoutTitleStyled.DS';
import { CheckoutTitleStyledOV } from './OV/CheckoutTitleStyled.OV';
import { CheckoutTitleStyled } from './CheckoutTitleStyled';

export interface CheckoutTitleProps extends SC {
    status?: string;
    journeyType: string;
    isAssistedFinance?: boolean;
    isRentJourney?: boolean;
}

const CheckoutTitle = (props: CheckoutTitleProps) => {
    if (BRAND === 'OV') return <CheckoutTitleStyledOV {...props} />;
    if (BRAND === 'AC') return <CheckoutTitleStyledAC {...props} />;
    if (BRAND === 'AP') return <CheckoutTitleStyledAP {...props} />;
    if (BRAND === 'DS') return <CheckoutTitleStyledDS {...props} />;
    return <CheckoutTitleStyled {...props} />;
};

export default CheckoutTitle;
